import type { AnchorHTMLAttributes } from 'react';
import { useLinkClickHandler } from 'react-router';
import { publicUrl } from '../lib/publicUrl';

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & { to: `/${string}` };

/** Copy/share/new-tab uses the public domain; ordinary taps keep the current signed-in router. */
export function PublicLink({ to, target, onClick, ...props }: Props) {
  const navigate = useLinkClickHandler<HTMLAnchorElement>(to, { target });
  return <a {...props} target={target} href={publicUrl(to)} onClick={(event) => {
    onClick?.(event);
    if (!event.defaultPrevented) navigate(event);
  }} />;
}
